var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.21 280.43",
    width: 24,
    height: 24,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210.21,
    height: 280.43,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.51,
    y: 43.03,
    width: 24.09,
    height: 50.02,
    fill: "#130754"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.51,
    y: 145.78,
    width: 24.09,
    height: 50.02,
    fill: "#130754"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.51,
    y: 107.65,
    width: 24.09,
    height: 23.6,
    fill: "#ffca00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.81,
    y: 84.15,
    width: 24.09,
    height: 166.27,
    fill: "#130754"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 112.41,
    y: 187.05,
    width: 24.09,
    height: 50.02,
    fill: "#130754"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 112.41,
    y: 84.21,
    width: 24.09,
    height: 50.02,
    fill: "#130754"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 112.41,
    y: 148.84,
    width: 24.09,
    height: 23.6,
    fill: "#e70488"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 30,
    width: 24.09,
    height: 166.27,
    fill: "#130754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/Pandas.310e871ca79bf48590ad1c787686ed98.svg";
export { ForwardRef as ReactComponent };